"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatTime = void 0;
var type_guard_1 = require("@webnuts/type-guard");
var isNumber = (0, type_guard_1.is)((0, type_guard_1.number)());
var isDate = (0, type_guard_1.is)((0, type_guard_1.instanceOf)(Date));
var isISO8601 = (0, type_guard_1.is)((0, type_guard_1.format)('date-iso8601'));
var isTime12h = (0, type_guard_1.is)((0, type_guard_1.format)('time12h'));
var isTime24h = (0, type_guard_1.is)((0, type_guard_1.format)('time24h'));
var isTime24hFull = (0, type_guard_1.is)((0, type_guard_1.format)('time24h-full'));
var convertTime12to24 = function (time12h) {
    var modifier = time12h.endsWith('am') ? 'am' : 'pm';
    // eslint-disable-next-line prefer-const
    var _a = __read(time12h.split(/(?::|am|pm)+/), 2), hours = _a[0], minutes = _a[1];
    if (hours === '12') {
        hours = '00';
    }
    return [modifier === 'pm' ? parseInt(hours, 10) + 12 : parseInt(hours, 10), parseInt(minutes, 10)];
};
function formatTime(value, options) {
    var _a = __assign({}, options), locale = _a.locale, timeZone = _a.timeZone, style = _a.style, hourCycle = _a.hourCycle;
    var locales = locale === undefined ? [] : [locale];
    var timeStyleOptions = style === undefined
        ? { timeStyle: 'medium' }
        : typeof style === 'object'
            ? Object.keys(style).length === 0
                ? { hour: 'numeric', minute: 'numeric', second: 'numeric' }
                : style
            : { timeStyle: style };
    var timeZoneName = (typeof style === 'object' ? style : { timeZoneName: undefined }).timeZoneName;
    var formatter = new Intl.DateTimeFormat(locales, __assign(__assign(__assign({}, timeStyleOptions), { hourCycle: hourCycle }), { timeZone: timeZone, timeZoneName: timeZoneName }));
    if (isNumber(value) || isDate(value)) {
        return formatter.format(value);
    }
    var timeType = isISO8601(value)
        ? 'iso8601'
        : isTime12h(value)
            ? 'time12h'
            : isTime24h(value)
                ? 'time24h'
                : isTime24hFull(value)
                    ? 'time24h-full'
                    : undefined;
    if (timeType === 'iso8601') {
        var date = new Date(value);
        return formatter.format(date);
    }
    if (timeType === 'time12h') {
        var date = new Date();
        var _b = __read(convertTime12to24(value), 2), hours = _b[0], minutes = _b[1];
        date.setHours(hours, minutes, 0, 0);
        return formatter.format(date);
    }
    if (timeType === 'time24h' || timeType === 'time24h-full') {
        var date = new Date();
        var _c = __read(value.split(':'), 3), hour = _c[0], minute = _c[1], second = _c[2];
        date.setHours(parseFloat(hour), parseFloat(minute), parseFloat(second !== null && second !== void 0 ? second : 0), 0);
        return formatter.format(date);
    }
    throw new type_guard_1.FunctionAssertionError('formatTime', 1, [
        {
            path: [0],
            rule: 'type',
            setting: ['Date', 'number', 'format-date-iso-8601', 'format-time12h', 'format-time24h', 'format-time24h-full'],
            actual: value
        }
    ]);
}
exports.formatTime = formatTime;
//# sourceMappingURL=format-time.js.map